// eslint-disable-next-line import/prefer-default-export
export const MAX_MEMBER_PER_LICENSE = 20;

export const LICENSE_STATUS_NAMES_FULL = {
  ADMINISTRATOR: 'Administrator',
};

export const LICENSE_PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  BUNDLE: 'bundle',
};
